// src/components/gifts/GiftCard.jsx
import Currency from "../Currency";

export default function GiftCard({ gift, onOpen, variant = "row" }) {
  const deliversLabel =
    gift.deliversTo === "united_states"
      ? "Delivers: United States"
      : gift.deliversTo === "usa_canada_uk"
      ? "Delivers: USA, Canada, UK"
      : "Delivers: All Countries";
  const sizeClass = variant === "grid" ? "w-full" : "flex-shrink-0 w-[130px] sm:w-[180px]";

  return (
    <button
      onClick={() => onOpen(gift)}
      className={`${sizeClass} text-left bg-white dark:bg-gray-900 rounded-lg sm:rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden hover:border-purple-300 dark:hover:border-purple-700 hover:shadow-md transition`}
    >
      <div className="relative w-full aspect-square bg-gray-100 dark:bg-gray-800">
        <img
          src={gift.imageUrl}
          alt={gift.title}
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <span className="absolute top-1 left-1 sm:top-1.5 sm:left-1.5 px-1.5 py-0.5 rounded-full bg-black/70 text-white text-[8px] sm:text-[10px] font-medium leading-none">
          {gift.deliveryTimeLabel}
        </span>
        {gift.isCustom && (
          <span className="absolute top-1 right-1 sm:top-1.5 sm:right-1.5 px-1.5 py-0.5 rounded-full bg-white text-gray-900 text-[8px] sm:text-[10px] font-bold leading-none">
            CUSTOM
          </span>
        )}
        <span className="absolute bottom-1 left-1 sm:bottom-1.5 sm:left-1.5 px-1.5 py-0.5 rounded-full bg-blue-600 text-white text-[7px] sm:text-[9px] font-medium leading-none">
          {deliversLabel}
        </span>
      </div>

      <div className="p-1.5 sm:p-2.5">
        <p className="text-[9px] sm:text-xs font-bold text-gray-900 dark:text-white uppercase leading-tight line-clamp-2 mb-0.5">
          {gift.title}
        </p>
        <p className="text-[10px] sm:text-sm font-bold text-purple-600 dark:text-purple-400">
          <Currency amount={gift.priceNgn} />
        </p>
      </div>
    </button>
  );
}